import { AgGridReact } from "ag-grid-react";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { closeGroupModal } from "src/actions/group";
import { defaultGridOptions } from "src/config/agGrid";
import {
  getAllGroupsById,
  getGroupsModalShow,
  getGroupsSearchResult,
  getUsersById,
} from "src/reducers";
import type { AppState, UsersById } from "src/types";
import Header from "./Header";
import New from "./New";
import { getColumns } from "./Table/columns";
import { overlayComponentParams } from "./constants";
import { GridWrapper, GroupsTableContainer } from "./styles";

const Groups = (): React.ReactElement => {
  const dispatch = useDispatch();
  const groupsById = useSelector(({ app }: { app: AppState }) =>
    getAllGroupsById(app),
  );
  const showGroupModal = useSelector(({ app }: { app: AppState }) =>
    getGroupsModalShow(app),
  );
  const groups = useSelector(({ app }: { app: AppState }) =>
    getGroupsSearchResult(app),
  );
  const usersById: UsersById =
    useSelector(({ app }: { app: AppState }) => getUsersById(app)) || {};
  const gridRef = useRef<AgGridReact>(null);
  const [searchText, setSearchText] = useState("");

  const handleSearch = (value: string) => {
    setSearchText(value);
    if (gridRef.current?.api) {
      gridRef.current.api.setGridOption("quickFilterText", value);
    }
  };

  const handleCloseGroupModal = () => {
    dispatch(closeGroupModal());
  };

  const columns = getColumns({ groupsById: groupsById, usersById: usersById });

  const rowData = groups.map((id) => ({ id: Number(id) }));

  return (
    <>
      <Header text={searchText} handleSearch={handleSearch} />
      <GroupsTableContainer>
        <GridWrapper>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            columnDefs={columns}
            animateRows={true}
            getRowId={(params) => String(params.data?.id || "")}
            overlayComponentParams={overlayComponentParams}
            {...defaultGridOptions}
          />
        </GridWrapper>
      </GroupsTableContainer>
      {showGroupModal ? <New handleClose={handleCloseGroupModal} /> : null}
    </>
  );
};

export default Groups;
